<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            persistent
            max-width="370">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>

                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ submitText }}
                    </v-card-title>
                </div>
                <v-card-text>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-container>
                            <v-row>
                                <v-col
                                    cols="12">
                                    <v-text-field
                                        :placeholder="$vuetify.lang.t('$vuetify.savePlaceForm.namePlace')"
                                        v-model="form.name"
                                        solo
                                        dense
                                        :rules="inputRules"
                                        :error-messages="errors.name">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :placeholder="$vuetify.lang.t('$vuetify.savePlaceForm.latitude')"
                                        v-model="form.lat"
                                        type="number"
                                        solo
                                        dense
                                        :rules="inputRules"
                                        :error-messages="errors.lat">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :placeholder="$vuetify.lang.t('$vuetify.savePlaceForm.longitude')"
                                        v-model="form.lon"
                                        type="number"
                                        solo
                                        dense
                                        :rules="inputRules"
                                        :error-messages="errors.lon">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        :placeholder="$vuetify.lang.t('$vuetify.savePlaceForm.radian')"
                                        v-model="form.radian"
                                        type="number"
                                        solo
                                        dense
                                        :rules="inputRules"
                                        :error-messages="errors.radian">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <div class="modal-save-btn">
                        <v-btn
                            width="200"
                            color="primary"
                            @click="submit()">
                            {{ $vuetify.lang.t('$vuetify.savePlaceForm.save') }}
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
    name: 'CompanyHolidayForm',

    props: {
        mode: {
            type: String,
            default: null
        },
        formValue: Object
    },

    directives: {
        mask
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        submitText () {
            if (this.mode === 'create') {
                return this.$vuetify.lang.t('$vuetify.savePlaceForm.createPlace')
            }
            return this.$vuetify.lang.t('$vuetify.savePlaceForm.updatePlace')
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                name: '',
                lat: '',
                lon: '',
                radian: ''
            },
            dateFormatted: '',
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.savePlaceForm.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.savePlaceForm.thisFieldIsExceededCharacters)
            ],
            errors: {}
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },

        closeModal () {
            this.$refs.form.resetValidation()
            this.dialog = false
            this.errors = {}
            this.datePickerShow = false
            this.clearForm()
            this.$emit('modal-closed')
        },

        clearForm () {
            this.form = {
                name: '',
                lat: '',
                lon: '',
                radian: ''
            }
        },

        getFormData () {
            this.form = {
                name: this.form.name.trim(),
                lat: parseFloat(this.form.lat),
                lon: parseFloat(this.form.lon),
                radian: parseInt(this.form.radian)
            }
            return this.form
        },

        async createPlace () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.post('/check-in/create', this.getFormData())
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
            }
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.dialog = false
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.savePlaceForm.congratulation,
                    text: this.trans.savePlaceForm.placeIsCreated,
                    type: 'success'
                })
            }
        },

        async updatePlace () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.put(`check-in/edit/${this.formValue.id}`, this.getFormData())
            if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.dialog = false
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.savePlaceForm.congratulation,
                    text: this.trans.savePlaceForm.placeIsUpdated,
                    type: 'success'
                })
            }
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }
            if (this.mode === 'create') {
                await this.createPlace()
            } else if (this.mode === 'update') {
                await this.updatePlace()
            }
        }

    },

    mounted () {
        this.registerLang({
            savePlaceForm: [
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'congratulation',
                'placeIsCreated',
                'placeIsUpdated'
            ]
        })
    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
            } else if (newValue === 'update') {
                this.form = { ...this.formValue }
            }
        },
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>
